/** Konstanter for gjentakende fakturaer (speiler backend services/recurring.py). */
import { Repeat, PauseCircle, CheckCircle2 } from "lucide-react";

export const FREQUENCIES = [
  { value: "uke", label: "Hver uke", short: "Ukentlig" },
  { value: "maned", label: "Hver måned", short: "Månedlig" },
  { value: "kvartal", label: "Hvert kvartal", short: "Kvartalsvis" },
  { value: "ar", label: "Hvert år", short: "Årlig" },
];

export const PERIOD_OFFSETS = [
  { value: "forrige", label: "Forrige periode (etterskudd)", hint: "F.eks. timer for måneden som er gått" },
  { value: "samme", label: "Samme periode som fakturadatoen", hint: "F.eks. abonnement for inneværende måned" },
  { value: "neste", label: "Neste periode (forskudd)", hint: "F.eks. husleie som betales på forskudd" },
];

export const RECURRING_STATUS = {
  aktiv: { label: "Aktiv", cls: "status-betalt", icon: Repeat },
  pauset: { label: "Pauset", cls: "status-ma_kontrolleres", icon: PauseCircle },
  avsluttet: { label: "Avsluttet", cls: "status-avvist", icon: CheckCircle2 },
};

export const frequencyLabel = (v) => FREQUENCIES.find((f) => f.value === v)?.label || v;
export const frequencyShort = (v) => FREQUENCIES.find((f) => f.value === v)?.short || v;
